import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
} from 'react-bootstrap';
import classnames from 'classnames';
import Spinner from '../Spinner.jsx';
import styles from './BucketSelector.css';

class BucketSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasSelectedAll: false,
      isSelectingAll: false,
      itemsOpen: false,
      openedOnce: false,
      toggledVisibility: false,
    };
  }

  componentDidUpdate(prevProps) {
    let newState = {};
    if ((prevProps.listFilter !== this.props.listFilter) ||
      (prevProps.selectedItems !== this.props.selectedItems)) {
      newState = {hasSelectedAll: false};
    }
    newState.toggledVisibility = (prevProps.selectedItems.length === 0 && this.props.selectedItems.length > 0)
      || (this.props.selectedItems.length === 0 && prevProps.selectedItems.length > 0);

    if (newState.hasSelectedAll !== undefined || newState.toggledVisibility !== this.state.toggledVisibility) {
      this.setState(newState);
    }
  }

  renderSelectedItems() {
    let {
      onDeselectItem,
      selectedItems,
      transformSelectedItem,
    } = this.props;

    return selectedItems.map(item => (
      <span
        className={styles.item}
        key={item}
      >
        {transformSelectedItem(item)}
        <i
          onClick={() => {
            onDeselectItem(item);
            if (this.props.selectedItems.length === 0) {
              this.setState({itemsOpen: false, openedOnce: false});
            }
          }}
          className={classnames("fa fa-times", styles.itemRemove)}
        />
      </span>
    ));
  }

  render() {
    let {
      itemType,
      onDeselectAll,
      onSelectAll,
      onView,
      selectedItems,
      totalItems,
    } = this.props;
    let {
      hasSelectedAll,
      isSelectingAll,
      itemsOpen,
      openedOnce,
      toggledVisibility,
    } = this.state;

    let hideSelector = selectedItems.length === 0;
    let hideInitially = hideSelector && !toggledVisibility;
    let selectorClass = hideInitially ? styles.hideInitially : (hideSelector ? styles.hide : (toggledVisibility ? styles.show : ''));

    return (
      <div
        className={classnames(styles.container, selectorClass)}
      >
        <span>{selectedItems.length} Selected</span>
        <span className={styles.separator}>|</span>
        <Button
          bsStyle="link"
          className={styles.link}
          disabled={isSelectingAll || hasSelectedAll}
          onClick={async () => {
            this.setState({isSelectingAll: true});

            await onSelectAll();

            this.setState({
              hasSelectedAll: true,
              isSelectingAll: false,
              toggledVisibility: false,
            });
          }}
        >
          <span>
            Select all {totalItems} {itemType}
            {
              isSelectingAll &&
              <Spinner />
            }
          </span>
        </Button>
        <span className={styles.separator}>|</span>
        <Button
          bsStyle="link"
          className={styles.link}
          onClick={() => {
            this.setState({hasSelectedAll: false, itemsOpen: false, openedOnce: false});
            onDeselectAll();
          }}
        >
          <span>Deselect all</span>
        </Button>
        <span
          className={styles.view}
          onClick={() => {
            this.setState({itemsOpen: !itemsOpen, openedOnce: true,});
            onView(!itemsOpen);
          }}
        >
          VIEW<i className={classnames(styles.caret, itemsOpen ? 'fa fa-angle-up' : 'fa fa-angle-down')}></i>
        </span>
        {
          openedOnce &&
          <div id="selectedItems" className={classnames(styles.itemsContainer, itemsOpen ? styles.itemsContainerOpen : styles.itemsContainerClosed)}>
            {this.renderSelectedItems()}
          </div>
        }
      </div>
    );
  }
}

BucketSelector.propTypes = {
  itemType: PropTypes.string,
  onDeselectAll: PropTypes.func,
  onDeselectItem: PropTypes.func,
  onSelectAll: PropTypes.func,
  onView: PropTypes.func,
  listFilter: PropTypes.string,
  selectedItems: PropTypes.arrayOf(PropTypes.string),
  totalItems: PropTypes.number,
  transformSelectedItem: PropTypes.func,
};

BucketSelector.defaultProps = {
  itemType: 'items',
  onView: () => {},
  selectedItems: [],
  totalItems: 0,
  transformSelectedItem: item => item
};

export default BucketSelector;